import { Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
var StyledPrivateWrapper = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    minHeight: '100vh',
    maxWidth: '100%',
    display: 'flex'
  };
  return styles;
});
var StyledMain = styled(Box)(function (_ref2) {
  var theme = _ref2.theme;
  var styles = {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1',
    width: '100%',
    backgroundColor: theme.colors.lightWhisper,
    overflow: 'hidden'
  };
  return styles;
});
var StyledContainerWrapper = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  var styles = {
    maxWidth: '100vw',
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    padding: pxToRem(16)
  };
  return styles;
});
var StyledContainer = styled(Box)(function (_ref4) {
  var theme = _ref4.theme;
  var styles = {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'column',
    padding: "".concat(pxToRem(44), " ").concat(pxToRem(40)),
    backgroundColor: theme.colors.white,
    borderRadius: pxToRem(16),
    border: "".concat(pxToRem(1), " solid ").concat(theme.colors.athensGray)
  };
  return styles;
});
export { StyledContainer, StyledContainerWrapper, StyledMain, StyledPrivateWrapper };